const courses = [
  {
    title: "Data Structure and Algorithm",
    provider: "Apna College",
    date: "June 2024",
    certificateUrl: "/media/certificates/data-structure-algorithm.pdf",
    skills: [
      "Solving Complex Algorithm",
      "Time & Space Complexity",
      "Performance Optimization",
    ],
  },
  {
    title: "Full Stack Development - MERN",
    provider: "Apna College",
    date: "April 2025",
    certificateUrl: "/media/certificates/mern-full-stack.pdf",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "Node.js",
      "Express.js",
      "React",
      "MongoDB",
      "API Gateway",
      "TailwindCss",
      "Bootstrap",
    ],
  },
  {
    title: "Microsoft Excel",
    provider: "Coursera",
    date: "January 2023",
    certificateUrl: "/media/certificates/microsoft-excel.pdf",
    skills: ["Formulas & Functions", "Charts & Graphs"],
  },
  // {
  //   title: "DofE - The Duke of Edinburgh's International Award",
  //   provider: "Coursera",
  //   date: "January 2024",
  //   certificateUrl:
  //     "/media/certificates/dofe-award.pdf",
  //   skills: ["Formulas & Functions", "Charts & Graphs"],
  // },
];

export default courses;
